import React from 'react';

type ParrotBrandMarkProps = {
  className?: string;
};

const ParrotBrandMark: React.FC<ParrotBrandMarkProps> = ({ className }) => (
  <span
    className={`${className ?? ''} inline-flex items-center justify-center overflow-visible`}
    aria-hidden="true"
  >
    <img
      src="/parrot-mark.png"
      alt=""
      className="h-full w-full scale-[1.65] object-contain"
      draggable={false}
    />
  </span>
);

export default ParrotBrandMark;
